import {
  FileText, FileImage, FileSpreadsheet, FileType, File as FileIcon,
} from "lucide-react";

export function fmtSize(bytes = 0) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "—";
  }
}

const IMG = ["png", "jpg", "jpeg", "gif", "webp", "svg"];
const SHEET = ["csv", "xlsx", "xls"];
const DOCX = ["doc", "docx", "txt", "md"];

export function fileExt(name = "") {
  return name.includes(".") ? name.split(".").pop().toLowerCase() : "";
}

export function FileGlyph({ filename, className = "w-5 h-5" }) {
  const ext = fileExt(filename);
  if (ext === "pdf") return <FileType className={className} />;
  if (IMG.includes(ext)) return <FileImage className={className} />;
  if (SHEET.includes(ext)) return <FileSpreadsheet className={className} />;
  if (DOCX.includes(ext)) return <FileText className={className} />;
  return <FileIcon className={className} />;
}

export const STATUS_STYLE = {
  Draft: "bg-white/8 text-[#A1A1AA]",
  "In Progress": "bg-blue-500/15 text-blue-300",
  Completed: "bg-emerald-500/15 text-emerald-300",
  Submitted: "bg-indigo-500/15 text-indigo-300",
  Approved: "bg-[#D4AF37]/15 text-[#D4AF37]",
  Expired: "bg-red-500/15 text-red-300",
  Archived: "bg-zinc-500/15 text-zinc-300",
};

// Build a nested tree from a flat folder list.
export function buildTree(folders) {
  const byParent = {};
  folders.forEach((f) => {
    const p = f.parent_id || "__root__";
    (byParent[p] = byParent[p] || []).push(f);
  });
  const attach = (parentId) =>
    (byParent[parentId] || [])
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((f) => ({ ...f, children: attach(f.folder_id) }));
  return attach("__root__");
}

// Path (breadcrumb) from a folder id back to root.
export function folderPath(folders, folderId) {
  const map = Object.fromEntries(folders.map((f) => [f.folder_id, f]));
  const path = [];
  let cur = map[folderId];
  while (cur) {
    path.unshift(cur);
    cur = cur.parent_id ? map[cur.parent_id] : null;
  }
  return path;
}
